/**
 * LE SIGNAL DE LA CLOCHE : « ce qui attend l'utilisateur a peut-être changé ».
 *
 * La fiche d'une demande le donne APRÈS l'avoir ouverte : c'est cette ouverture
 * qui la marque lue côté API. La cloche qui se rechargeait d'elle-même au
 * changement d'écran partait en même temps que la fiche, et relisait l'état
 * d'avant — le compteur restait à 1 sur une demande qu'on venait d'ouvrir.
 */
const ecouteurs = new Set<() => void>();

export function surRafraichissementCloche(f: () => void): () => void {
  ecouteurs.add(f);
  return () => ecouteurs.delete(f);
}

export function rafraichirCloche(): void {
  for (const f of ecouteurs) f();
}
